import React, { forwardRef, memo, useState } from 'react';
import { withBillingWriteAccess } from 'contexts/adminAccess';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { useParams } from 'react-router-dom';

import AchTransactionsCheckDialog from './AchTransactionsCheckDialog';

import { AchActionProps } from './achVerificationTypes';

// RLPR-20420 transaction action: look for the debit of a pending ACH deposit in the user's bank transactions
const CheckAchTransactionsField = forwardRef<HTMLLIElement, AchActionProps>((props, ref) => {
  const { record, hideAction } = props;

  const { id } = useParams<{ id: string }>();

  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [hasOpened, setHasOpened] = useState(false);

  if (hideAction) {
    return null;
  }

  return (
    <>
      <Tooltip title="Reads the user's bank transactions through Stripe to see whether the ACH debit already posted">
        <MenuItem
          ref={ref}
          onClick={() => {
            setHasOpened(true);
            setOpenDialog(true);
          }}>
          Check bank transactions
        </MenuItem>
      </Tooltip>

      {hasOpened && (
        <AchTransactionsCheckDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          userId={id}
          record={record}
        />
      )}
    </>
  );
});

export default withBillingWriteAccess(memo(CheckAchTransactionsField));
